export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#0B4F6C] to-[#14B8A6] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/d4c6fcf69c7d885228da6e53459f8742/ce48a62436aa422819467cefe130a97b.jpeg"
                alt="CareJoint Logo"
                className="h-12 w-12 object-contain"
              />
              <div className="flex flex-col">
                <span className="text-lg font-bold">CareJoint Physiotherapy</span>
                <span className="text-xs text-white/80">Godbest</span>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Transforming pain into potential and strength through expert clinical care and genuine compassion.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('techniques')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Techniques
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-lg mt-0.5 flex-shrink-0"></i>
                <div className="text-sm text-white/80">
                  <a href="tel:+256782322561" className="hover:text-white transition-colors block">
                    +256 782 322 561
                  </a>
                  <a href="tel:+256758903109" className="hover:text-white transition-colors block">
                    +256 758 903 109
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-lg mt-0.5 flex-shrink-0"></i>
                <div className="text-sm text-white/80">
                  <a href="mailto:carejoint8@gmail.com" className="hover:text-white transition-colors block">
                    carejoint8@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-white/80">Nsambya Estate, Kampala, Uganda</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-3 mb-6">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-white text-[#0B4F6C] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap"
            >
              Book Consultation
            </button>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-white/80">
              © 2023 CareJoint Physiotherapy Clinic. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}